/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-16 13:36:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/SecondaryActionButtonStyle/index.tsx
 */

import React from 'react';

import { store } from 'src/store';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { suffix } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSecondaryActionButtonStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onSecondaryActionButtonStyleChange,
  onSecondaryActionButtonStyleReset,
} from '../slice';

const idSet = {
  outlineColour: suffix + 'SecondaryActionButtonStyleOutlineColour',
  textColour: suffix + 'SecondaryActionButtonStyleTextColour',
};
const SecondaryCallToActionButtonStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const { backgroundColor, textColor } = data || {};

  const _d = useDispatch();

  const handleOnOutlineChange = (backgroundColor) => {
    _d(onSecondaryActionButtonStyleChange({ backgroundColor }));
  };

  const handleOnTextChange = (textColor) => {
    _d(onSecondaryActionButtonStyleChange({ textColor }));
  };

  return (
    <React.Fragment>
      <Section>
        <ItemWrapper
          id={idSet.outlineColour}
          title={getI18n('salesChannelContent.index.outlineColour')}>
          <ColorPicker
            id={idSet.outlineColour}
            onChange={handleOnOutlineChange}
            multi
            color={backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.textColour}
          title={getI18n('general.textColour')}>
          <ColorPicker
            onChange={handleOnTextChange}
            multi
            id={idSet.textColour}
            color={textColor}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(SecondaryCallToActionButtonStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.secondaryCallToActionButtonStyle,
  getContent: getSecondaryActionButtonStyle,
  title: getI18nFromGeneral(
    'general.hOCTitle.secondaryCallToActionButtonStyle',
  ),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onSecondaryActionButtonStyleReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
